type Props = {
  link?: string;
  className?: string;
};

export default function SiteFavicon(props: Props) {
  return (
    <img
      src={`https://www.google.com/s2/favicons?sz=64&domain_url=${props.link}`}
      className={props.className || ""}
    />
  );
}
